import { render, staticRenderFns } from "./input-field.vue?vue&type=template&id=0c72a53e&scoped=true"
import script from "./input-field.vue?vue&type=script&lang=js"
export * from "./input-field.vue?vue&type=script&lang=js"
import style0 from "./input-field.vue?vue&type=style&index=0&id=0c72a53e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c72a53e",
  null
  
)

export default component.exports